export default __webpack_public_path__ + "assets/images/icon-user-small.5e38b9338d210e3d88aeae4ec87d8f97.svg";